import React, { useState, useEffect } from "react";
import GoogleDrivePicker from "google-drive-picker";
import axios from "axios";

const GDriveParent = ({ children }) => {
    const [openPicker, authRes] = GoogleDrivePicker();
    const [authToken, setAuthToken] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);

    const developerKey = "AIzaSyAzM3Np-VdvelHvagawauF2piq_yhC9lcE"; // Replace with your Google API Key
    const clientId = "4414070894-n3hd59hhhk8cr1tlee8ekaattc7udtgk.apps.googleusercontent.com"; // Replace with your OAuth Client ID

    const googleMimeTypeMapping = {
        "application/vnd.google-apps.document": "docx",
        "application/vnd.google-apps.spreadsheet": "xlsx",
        "application/vnd.google-apps.presentation": "pptx",
        "application/vnd.google-apps.form": "pdf",
    };

    const getReplacedFileType = (googleMimeType) => {
        return googleMimeTypeMapping[googleMimeType] || googleMimeType;
    };

    const handlePickerOpen = () => {
        openPicker({
            clientId: clientId,
            developerKey: developerKey,
            viewId: "DOCS",
            token: authToken,
            showUploadView: true,
            showUploadFolders: true,
            supportDrives: true,
            multiselect: true,
            callbackFunction: async (data) => {
                if (data.action === "cancel") {
                } else if (data.docs && data.docs.length > 0) {
                    const downloadedFiles = await downloadFiles(data.docs);
                    setSelectedFiles(downloadedFiles);

                    // Notify child about the selected files
                    const iframe = document.getElementById("child-iframe");
                    iframe.contentWindow.postMessage(
                        { action: "filesSelected", files: downloadedFiles },
                        "*"
                    );
                }
            },
        });
    };

    useEffect(() => {
        if (authRes) {
            setAuthToken(authRes.access_token);
        }

        const handleChildMessage = (event) => {
            if (event.data.action === "openPicker") {
                handlePickerOpen();
            }
        };

        window.addEventListener("message", handleChildMessage);

        return () => {
            window.removeEventListener("message", handleChildMessage);
        };
    }, [authRes]);

    const downloadFiles = async (files) => {
        return await Promise.all(
            files?.map(async (file) => {
                try {
                    const downloadUrl = file.url;
                    const response = await axios.get(downloadUrl, {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                        responseType: "blob",
                    });

                    const blob = response.data;
                    if (blob) {
                        return new File(
                            [blob],
                            `${file.name}.${getReplacedFileType(file.mimeType)}`,
                            { type: getReplacedFileType(file.mimeType) }
                        );
                    }
                } catch (error) {
                    console.error("Error downloading file:", error);
                }
            })
        ).then((results) => results.filter((file) => file !== undefined));
    };

    return <>{children}</>;
};

export default GDriveParent;
